import { z } from 'zod';

const dashboardPublisherSchema = z
  .object({
    id: z.string().trim().min(1),
    name: z.string().trim().min(1),
  })
  .loose();

export const dashboardPublishersPageSchema = z
  .object({
    content: z.array(dashboardPublisherSchema),
  })
  .loose();
